const validationMessages = {
    required: "The :field field is required.",
    email: "The :field must be a valid email address.",
    minLength: "The :field must be at least X digits.",
    maxLength: "The :field cannot be more than X digits."
}

export default validationMessages



//////////////////
// WEBPACK FOOTER
// ./vue/src/lang/en/validation-messages.js
// module id = 599
// module chunks = 0